import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { useState } from "react";
import moment from "moment";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { desformatarValorMonetario } from "../../../../../helpers/unmask";
import DateComIntervalo from "../../../../../components/DateComIntervalo";
import { formatarInputValorMonetário } from "../../../../../helpers/masks";
import SelectContaCaixaBanco from "../../../../../components/SelectsSimpleApiQuery/SelectContaCaixaBanco";
import { TFiltrosLancamentos } from "./Listagem";

export default function DialogFiltersLancamentos({
    open,
    filtrosAtuais,
    onClose,
    onConfirm
}: DialogFiltersLancamentosProps) {

    const [internalFilters, setInternalFilters] = useState<TFiltrosLancamentos>(filtrosAtuais);

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternalFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleConfirm = (filters: TFiltrosLancamentos) => {

        if (filters.valor) {
            const valorLimpo = desformatarValorMonetario(filters.valor);
            filters.valor_igual = valorLimpo;
        }
        if (filters.banco && typeof filters.banco === "object") {
            filters.codigo_banco_contem = [filters.banco.codigo];
        }
        onConfirm(filters)
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Filtros</DialogTitle>
            <DialogContent>

                <Grid container spacing={2} mt={0.8}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            label="Valor"
                            variant="outlined"
                            value={internalFilters.valor || ""}
                            fullWidth
                            onChange={(e) => handleInsertFiltros("valor", formatarInputValorMonetário(e.target.value))}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <SelectContaCaixaBanco
                            label="Bancos"
                            value={internalFilters.banco}
                            onChange={(valor) => handleInsertFiltros("banco", valor)}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <DateComIntervalo
                            labelInput="Data"
                            datePickerView={["year", "month", "day"]}
                            formatString="DD/MM/YYYY"
                            data={{
                                inicial: internalFilters.data_movimentacao_inicio ? moment(internalFilters.data_movimentacao_inicio) : null,
                                final: internalFilters.data_movimentacao_fim ? moment(internalFilters.data_movimentacao_fim) : null
                            }}
                            onChangeData={(data) => {
                                handleInsertFiltros("data_movimentacao_inicio", data.inicial?.format("YYYY-MM-DD"))
                                handleInsertFiltros("data_movimentacao_fim", data.final?.format("YYYY-MM-DD"))
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onConfirm({})}>Limpar</Button>
                <Button variant="contained" onClick={() => handleConfirm(internalFilters)}>Aplicar</Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogFiltersLancamentosProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (filters: TFiltrosLancamentos) => void;
    filtrosAtuais: TFiltrosLancamentos;
}



